const KEY = "perceptica:seenReports";

function safeWindow(): Window | null {
  return typeof window === "undefined" ? null : window;
}

function readSeenSlugs(): Set<string> {
  const w = safeWindow();
  if (!w) return new Set();
  try {
    const raw = w.localStorage.getItem(KEY);
    if (!raw) return new Set();
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? new Set(arr.filter((s) => typeof s === "string")) : new Set();
  } catch {
    return new Set();
  }
}

function writeSeenSlugs(set: Set<string>): void {
  const w = safeWindow();
  if (!w) return;
  try {
    w.localStorage.setItem(KEY, JSON.stringify(Array.from(set)));
  } catch {
    /* ignore quota / disabled storage */
  }
}

/**
 * Returns the set of slugs that are NEW for this visitor.
 * On first visit (no stored key), seeds storage with allSlugs and returns
 * an empty set so first-time visitors see no badges.
 */
export function getNewSlugs(allSlugs: string[]): Set<string> {
  const w = safeWindow();
  if (!w) return new Set();
  let hasKey: boolean;
  try {
    hasKey = w.localStorage.getItem(KEY) !== null;
  } catch {
    return new Set();
  }
  if (!hasKey) {
    writeSeenSlugs(new Set(allSlugs));
    return new Set();
  }
  const seen = readSeenSlugs();
  const newSet = new Set<string>();
  for (const slug of allSlugs) {
    if (!seen.has(slug)) newSet.add(slug);
  }
  return newSet;
}

export function markSeen(slugs: string[]): void {
  if (slugs.length === 0) return;
  const seen = readSeenSlugs();
  let changed = false;
  for (const s of slugs) {
    if (!seen.has(s)) {
      seen.add(s);
      changed = true;
    }
  }
  if (changed) writeSeenSlugs(seen);
}